// Explicit purpose, not paid==0: credit/offline sales are still payment receipts.
export const isCheckingReceipt = tx => tx?.is_checking === true || tx?.invoice_no === 'DRAFT';
export const CHECKING_TITLE = 'BUKAN BUKTI PEMBAYARAN';
export const CHECKING_FOOTER = 'SILAKAN LAKUKAN PEMBAYARAN\nDI KASIR PEMBAYARAN';
